// extracted by mini-css-extract-plugin
module.exports = {"gridContainerLarge":"gridContainerLarge___2QrfG"};